module.exports = __webpack_public_path__ + "static/img/banner-corona.459e433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-corona.png
// module id = ilau
// module chunks = 1